import { FunnelIcon, MessageSquareIcon } from 'lucide-react';

import { DIALOGS_TABLE_NAME } from '@/entities/conversations';
import { useHasPermission } from '@/entities/profile';
import { usePinnedPresetRoutes } from '@/entities/settings';
import { SidebarDynamicMenuItem } from '@/shared/lib';

/**
 * Пункты динамического подменю закреплённых пресетов списка диалогов под группой «Контроль».
 *
 * Пункт ведёт на адрес раздела своего пресета; сам пресет применяет адрес (`usePresetSectionSync`).
 */
export const useDialogPresetMenuItems = (): SidebarDynamicMenuItem[] => {
  const pinnedRoutes = usePinnedPresetRoutes(DIALOGS_TABLE_NAME);
  const allowView = useHasPermission('VIEW_CONVERSATION');

  if (!allowView) {
    return [];
  }

  return pinnedRoutes.map(({ preset, path }) => ({
    key: preset.id,
    path,
    icon: (
      <span className="relative flex size-4 shrink-0">
        <MessageSquareIcon size={16} strokeWidth={1.25} />
        {/* Отступ снизу компенсирует хвостик облачка: значок встаёт по центру его тела */}
        <span className="absolute inset-0 flex items-center justify-center pb-0.5">
          <FunnelIcon size={8} strokeWidth={2.5} />
        </span>
      </span>
    ),
    label: preset.name,
  }));
};
